export default __webpack_public_path__ + "static/media/img4.4b244b04.jpg";